import * as React from 'react';
import { Message, Grid, Container } from 'semantic-ui-react';
var MaintenanceMode = function () {
    return (React.createElement(Container, { className: "mt3" },
        React.createElement(Grid, null,
            React.createElement(Grid.Column, { width: 16 },
                React.createElement(Message, { info: true }, "Our team is currently working to upgrade the app and enhance your experience. It will take just a little while. We will be back in a few moments.")))));
};
export default MaintenanceMode;
